import type { SessionData } from '../../services/global-data/global-data.service';

export const applicationRoles = [
  'Administrator', 'SendoutManager', 'TemplateManager', 'UserManager', 'StoreManager',
] as const;

export type ApplicationRole = typeof applicationRoles[number];

export interface EffectiveAccess {
  roles: string[];
  editorStoreIds: number[];
  matchedStoreId: number | null;
}

export const noAccess: EffectiveAccess = { roles: [], editorStoreIds: [], matchedStoreId: null };

export function hasRole(access: { roles?: string[] }, role: ApplicationRole): boolean {
  return access.roles?.includes('Administrator') === true || access.roles?.includes(role) === true;
}

export function editorStoreIds(access: Partial<EffectiveAccess>): number[] {
  return access.editorStoreIds ?? [];
}

export function hasStoreContext(session: SessionData): boolean {
  return !!session.store && (session.storeImpersonation
    ? hasRole(session, 'SendoutManager')
    : editorStoreIds(session).includes(session.store.id));
}

export function landingPath(session: SessionData): string {
  if (session.storeImpersonation && hasStoreContext(session)) return 'overview';
  if (hasRole(session, 'SendoutManager')) return 'sendouts';
  if (editorStoreIds(session).length) return hasStoreContext(session) ? 'overview' : 'select-store';
  if (hasRole(session, 'TemplateManager')) return 'templates';
  if (hasRole(session, 'StoreManager')) return 'manage-stores';
  if (hasRole(session, 'UserManager')) return 'manage-users';
  return 'no-access';
}
